var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTestSwitcher(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    width: 150.45704,
    height: 150.45704,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 150.45704 150.45704",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: -1902.78193,
    y1: -1256.44709,
    x2: -1944.90512,
    y2: -1256.44709,
    gradientTransform: "translate(-1542.19152 -1228.11885) rotate(-180) scale(.853 1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#000"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#000",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -1897.20545,
    y1: -1279.93719,
    x2: -1939.39465,
    y2: -1279.93719,
    xlinkHref: "#linear-gradient"
  }), /*#__PURE__*/React.createElement("mask", {
    id: "mask",
    x: 0,
    y: 0,
    width: 150.45704,
    height: 150.45704,
    maskUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("g", {
    id: "qsh5rtmr1c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.9737,94.15319h56.4496v9.40356H13.9737v-9.40356ZM13.9737,117.6621h56.4496v9.40356H13.9737v-9.40356ZM79.77514,23.62646h56.4449v9.40356h-56.4449v-9.40356ZM70.4186,47.11656h65.80144v9.40356h-65.80144v-9.40356ZM131.29257,91.63304l-6.64832-6.64832-16.6208,16.6255-16.6255-16.6255-6.64832,6.64832,16.6255,16.6255-16.6255,16.6208,6.64832,6.64832,16.6255-16.6208,16.6208,16.6208,6.64832-6.64832-16.6208-16.6208,16.6208-16.6255Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.1288,37.7318h-37.59545v-18.80713h37.59545v18.80713Z",
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M71.44358,18.92467h13.30604v18.80713h-13.30604v-18.80713Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M117.42702,61.22191h-37.65188v-18.80713h37.65187s0,18.80713,0,18.80713Z",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.18725,42.41478h17.08158v18.80713h-17.08157v-18.80713Z"
  })))), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-3",
    x1: 0,
    y1: 75.22852,
    x2: 150.45704,
    y2: 75.22852,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#8100e0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.09285,
    stopColor: "#6b12e5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.26122,
    stopColor: "#4a2fee"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.43437,
    stopColor: "#3045f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.61198,
    stopColor: "#1d55fa"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.79671,
    stopColor: "#125efd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0f62fe"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-4",
    x1: 15.86465,
    y1: 31.01452,
    x2: 72.28604,
    y2: 31.01452,
    xlinkHref: "#linear-gradient-3"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,0h150.45704v150.45704H0V0Z",
    fill: "url(#linear-gradient-3)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M34.67178,39.87738l-12.17761-12.17762-6.62951,6.62951,18.80713,18.80713L72.28604,15.52215l-6.62951-6.62951-30.98475,30.98475Z",
    fill: "url(#linear-gradient-4)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTestSwitcher);
export default __webpack_public_path__ + "static/media/test_switcher.39b3e52203139f73d18668c1a074ba9c.svg";
export { ForwardRef as ReactComponent };